const WorkSection = () =>
{
    return <section class="work-section" id="work" aria-labelledby="work-title">
      <div class="section-heading">
        <div>
          <p class="eyebrow">01 / Private reel</p>
          <h2 id="work-title">A reel built for your brief.</h2>
        </div>
        <p class="reel-intro">
          Tell us what you are making and we will send a focused selection of relevant film, branded, music, photography, and AI-assisted work.
        </p>
      </div>

      <div class="reel-callout">
        <p>Private. Relevant. Curated.</p>
        <h3>See the work that fits your project.</h3>
        <a class="button button-dark" href="mailto:jose@playa-pictures.com?subject=Request%20a%20Playa%20Pictures%20Reel&amp;body=Hi%20Jose%2C%0A%0AI%27d%20like%20to%20request%20a%20reel.%0A%0AProject%20type%3A%0ADeadline%3A%0AWhat%20I%27d%20like%20to%20see%3A%0A%0AThanks%2C">
          Request Reel <span aria-hidden="true">↗</span>
        </a>
      </div>
    </section>
}

export default WorkSection